import { useProfileStore } from "@/store/profileStore";
import { useSettingsStore } from "@/store/settingsStore";
import { useUiStore } from "@/store/uiStore";

let sessionLoginHandler: (() => void) | null = null;
let sessionClearedHandler: (() => void) | null = null;
let handlingSessionExpired = false;

export function registerSessionLoginHandler(handler: () => void) {
  sessionLoginHandler = handler;
}

export function registerSessionClearedHandler(handler: () => void) {
  sessionClearedHandler = handler;
}

export function isSessionExpiredActive() {
  return handlingSessionExpired;
}

function clearAuthSessionState() {
  useProfileStore.getState().clearProfile();
  useSettingsStore.setState({
    legalEntityId: null,
    branchId: null,
    legalEntityName: null,
    branchName: null,
  });
  localStorage.removeItem("atlas-settings");

  const keycloak = (window as { keycloak?: { token?: string; refreshToken?: string; tokenParsed?: unknown } }).keycloak;
  if (keycloak) {
    keycloak.token = undefined;
    keycloak.refreshToken = undefined;
    keycloak.tokenParsed = undefined;
  }
}

export function completeSessionExpiredLogin() {
  handlingSessionExpired = false;
  useUiStore.getState().dismissActionFeedback();
  sessionLoginHandler?.();
}

export function handleSessionExpired() {
  if (handlingSessionExpired) return;
  handlingSessionExpired = true;

  useUiStore.getState().showActionFeedback({
    tone: "warning",
    title: "Session expired",
    message: "Your session has expired. Please sign in again to continue.",
    sessionExpired: true,
  });

  clearAuthSessionState();
  sessionClearedHandler?.();
}
